import { render } from "./BorderWrapper.vue?vue&type=template&id=69101932"
import script from "./BorderWrapper.vue?vue&type=script&lang=js"
export * from "./BorderWrapper.vue?vue&type=script&lang=js"

import "./BorderWrapper.vue?vue&type=style&index=0&id=69101932&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__